import {
  type IDisplayColour,
  type ISoftDelete,
} from '@principle-theorem/shared';

export interface ITreatmentCategory extends ISoftDelete {
  name: string;
  colour: IDisplayColour;
}
